import { render, staticRenderFns } from "./BaseWidget.vue?vue&type=template&id=6814a77e&scoped=true"
import script from "./BaseWidget.vue?vue&type=script&lang=ts"
export * from "./BaseWidget.vue?vue&type=script&lang=ts"
import style0 from "./BaseWidget.vue?vue&type=style&index=0&id=6814a77e&prod&lang=scss&scoped=true"
import style1 from "./BaseWidget.vue?vue&type=style&index=1&id=6814a77e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6814a77e",
  null
  
)

export default component.exports